export default ".mdc-icon-button[disabled] {\n  opacity: 0.5;\n}"